<app-dynamic-form (closeModal)="closeModal($event)" [model]="model" [service]="service"></app-dynamic-form>
<!--
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="form.value" [disabled]="!form.valid">{{ "LABEL.SAVE" | translate }}</button>
    <button mat-button [mat-dialog-close]="">{{ "LABEL.CANCEL" | translate }}</button>
  </div>
  -->